import { Dialog, DialogContent, Typography, Divider, Grid, Stack, Box, DialogTitle, IconButton } from "@mui/material";
import { formatCurrency } from "src/helper/convertNum";
import CloseIcon from "@mui/icons-material/Close";
import useDebtHistoryDetail from "src/hooks/debt/useDebtHistoryDetail";
import convertCurrency from "src/helper/convertCurrency";
import dayjs from "dayjs";
import DebtWarehousePrintDialog from "./DebtWarehousePrintDialog";
import useAppGlobal from "src/context/useAppGlobal";
import CopyToClipboard from "src/components/shared/CopyToClipboard";

export default function DebtHistoryDetailDialog({ open, onClose, selectedRow, isAllTab = false }) {
  const { data } = useDebtHistoryDetail(isAllTab ? selectedRow?.paymentLog : selectedRow?._id);
  const { handleOpenDialog } = useAppGlobal();
  const debtHistoryDetail = data?.data ?? {};

  const handlePreview = (row) => {
    handleOpenDialog({
      title: "Xem phiếu xuất",
      size: "xl",
      content: <DebtWarehousePrintDialog item={row} />,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <DialogTitle sx={{ pb: 1, fontWeight: "bold", px: "32px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="inherit"
          >
            Chi tiết Lịch sử thanh toán công nợ
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 4 }}>
        <Divider sx={{ bgcolor: "#E0E0E0", borderColor: "#E0E0E0", borderTopWidth: "0px" }} />
        <Stack
          spacing={3}
          mt="8px"
        >
          <Grid
            container
            rowSpacing={1}
          >
            <Grid
              item
              xs={6}
            >
              <Stack spacing={1.5}>
                <Box>
                  <Typography color="#989898">Kho xuất / NCC</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.warehouse?.name}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Kho nhận</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.warehouseDebt?.name}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Hình thức thanh toán</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.method === "Cash" ? "Tiền mặt" : "Chuyển khoản"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Số tiền thanh toán</Typography>
                  <Typography fontWeight="bold">{formatCurrency(debtHistoryDetail?.totalPaid || 0)}</Typography>
                  {debtHistoryDetail?.totalPaid && (
                    <Typography
                      color="#989898"
                      fontSize="12px"
                      fontStyle="italic"
                    >
                      {convertCurrency(debtHistoryDetail?.totalPaid || 0)} đồng
                    </Typography>
                  )}
                </Box>
                <Box>
                  <Typography color="#989898">Ngày thanh toán</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.paymentDate ? dayjs(debtHistoryDetail?.paymentDate).format("DD/MM/YYYY") : "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Kế toán xử lý</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.sales?.fullName}</Typography>
                </Box>
              </Stack>
            </Grid>
            <Divider sx={{ bgcolor: "#E0E0E0", borderColor: "#E0E0E0", borderTopWidth: "0px" }} />
            <Grid
              item
              xs={6}
            >
              <Stack spacing={1.5}>
                <Box>
                  <Typography color="#989898">Ngày tiền trên nội dung chuyển khoản</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.paymentDate ? dayjs(debtHistoryDetail?.paymentDate).format("DD/MM/YYYY") : "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Số tài khoản nhận thanh toán</Typography>
                  <Typography fontWeight="bold">
                    {debtHistoryDetail?.bankInfo?.ownerName} - STK {debtHistoryDetail?.bankInfo?.accountNumber}
                  </Typography>
                  <Typography color="#989898">
                    {debtHistoryDetail?.bankInfo?.bankName} - {debtHistoryDetail?.bankInfo?.branchName}
                  </Typography>
                  <Typography color="#989898">{debtHistoryDetail?.bankInfo?.branchName ?? "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Ghi chú</Typography>
                  <Typography fontWeight="bold">{debtHistoryDetail?.note ?? "-"}</Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Divider sx={{ bgcolor: "#E0E0E0", borderColor: "#E0E0E0", borderTopWidth: "0px" }} />
          <Stack spacing={2}>
            <Typography fontWeight="bold">Chi tiết Phiếu xuất/ Phiếu Nhập được thanh toán</Typography>
            {debtHistoryDetail?.inventoryNotes?.length > 0 ? (
              <Box
                sx={{
                  borderRadius: "12px",
                  border: "1px solid var(--grey)",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "80px 1fr 200px 250px",
                    backgroundColor: "var(--white)",
                    borderBottom: "1px solid var(--grey)",
                    px: 3,
                    py: 1.5,
                  }}
                >
                  <Typography
                    fontWeight="bold"
                    align="left"
                  >
                    STT
                  </Typography>
                  <Typography
                    fontWeight="bold"
                    align="left"
                  >
                    Mã Phiếu được thanh toán
                  </Typography>
                  <Typography
                    fontWeight="bold"
                    align="right"
                  >
                    Số tiền thanh toán
                  </Typography>
                  <Typography
                    fontWeight="bold"
                    pl="12px"
                  >
                    Mã Đơn hàng
                  </Typography>
                </Box>
                {debtHistoryDetail?.inventoryNotes?.map((row, index) => (
                  <Box
                    key={row.stt}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "80px 1fr 200px 250px",
                      px: 3,
                      py: 1.5,
                      borderBottom: index === debtHistoryDetail?.inventoryNotes?.length - 1 ? "none" : "1px solid var(--grey)",
                    }}
                  >
                    <Typography>{index + 1}</Typography>
                    <Typography
                      color="#007AFF"
                      sx={{ cursor: "pointer" }}
                      onClick={() => handlePreview(row)}
                    >
                      {row?.code ?? "-"}
                    </Typography>
                    <Typography align="right">{formatCurrency(row?.total || 0)}</Typography>

                    <CopyToClipboard
                      value={row?.contextCode}
                      isCenter={false}
                      pl="12px"
                      fontSize="14px"
                      color="#007AFF"
                      sx={{ maxWidth: "400px" }}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography fontWeight="bold">Không có chi tiết phiếu được thanh toán</Typography>
            )}
          </Stack>

          <Stack spacing={0.5}>
            <Typography fontWeight="bold">Số dư chưa đủ gạt Phiếu: {formatCurrency(debtHistoryDetail?.remainingDebt || 0)}</Typography>
            <Typography
              color="#989898"
              fontSize="12px"
              fontStyle="italic"
            >
              {convertCurrency(debtHistoryDetail?.remainingDebt || 0)} đồng
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
